module.exports = __webpack_public_path__ + "static/media/9C.dbc1a11e.svg";